import React, { useState } from "react";
import { RedocStandalone } from "redoc";
import { Button, styled } from "@mui/material";

const CustomButton = styled(Button)(({ theme }) => ({
  alignItems: "center",
  justifyContent: "center",
  outline: 0,
  border: 0,
  margin: 0,
  fontSize: "0.75rem",
  fontWeight: 700,
  fontFamily: "Roboto,-apple-system,BlinkMacSystemFont,Arial,sans-serif",
  lineHeight: 1.75,
  padding: "6px 16px",
  color: "#fff",
  backgroundColor: "#007AFF",
  boxShadow:
    "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
  height: 36,
  borderRadius: 5,
  textTransform: "none",
}));

const App = () => {
  const [source, setSource] = useState("./swagger.yml");
  console.log("source: ", source);
  return (
    <div className="App">
      <div
        style={{
          display: "flex",
          width: 300,
          height: 80,
          padding: 10,
          flexDirection: "column",
          position: "fixed",
          top: 0,
          zIndex: 999,
        }}
      >
        <img
          src="./ju-logo.png"
          alt="Justuno API"
          style={{
            height: 24,
            width: 120,
            marginBottom: 10,
          }}
        />
        <div style={{}}>
          <CustomButton
            variant="contained"
            size="small"
            onClick={() => setSource("./swagger.yml")}
          >
            Portal API
          </CustomButton>
          <CustomButton
            variant="contained"
            size="small"
            onClick={() => setSource("./swagger.yml")}
            style={{ marginLeft: 10 }}
            disabled="true"
          >
            Profile API
          </CustomButton>
        </div>
      </div>
      <div>
        <RedocStandalone
          specUrl={source}
          options={{
            nativeScrollbars: true,
            scrollYOffset: "80",
            theme: {
              colors: {
                primary: {
                  main: "#007AFF",
                  light: "#fff",
                },
                success: {
                  main: "rgba(28, 184, 65, 1)",
                  light: "#81ec9a",
                  dark: "#083312",
                  contrastText: "#000",
                },
                text: {
                  primary: "#182327",
                  secondary: "#4d4d4d",
                },
                http: {
                  get: "#4ECD5F",
                  post: "#007AFF",
                  put: "#5867C3",
                  delete: "#EA5151",
                  patch: "#F26430",
                },
              },
              typography: {
                fontSize: 12,
                fontFamily: "Roboto, sans-serif",
                optimizeSpeed: true,
                smoothing: "antialiased",
                headings: {
                  fontWeight: "bold",
                  lineHeight: "1em",
                  fontFamily: "Roboto, sans-serif",
                },
                code: {
                  fontFamily: "Roboto, sans-serif",
                  fontWeight: 600,
                  color: "rgba(92, 62, 189, 1)",
                  wrap: true,
                },
                links: {
                  color: "rgba(246, 20, 63, 1)",
                  visited: "rgba(246, 20, 63, 1)",
                  hover: "#fa768f",
                },
              },
              sidebar: {
                // width: 300,
                textColor: "#182327",
                backgroundColor: "#fff",
                rightLineColor: "#000",
                fontSize: "12px",
                width: "300px",
                // activeBgColor: "#007AFF",
                // activeTextColor: "#ffffff",
                spacing: {
                  paddingVertical: "6px",
                },
              },
              rightPanel: {
                backgroundColor: "#182327",
                textColor: "#ffffff",
              },
              logo: {
                // maxHeight: "25px",
                maxWidth: "200px",
                gutter: "15px 20px",
              },
              spacing: {
                sectionVertical: 20,
              },
              codeBlock: {
                borderRadius: "5px",
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default App;
